<template>
  <div class="earth_search pc-search noborder" :style="styleVal" style=" margin: 15px 32px;">
    <!-- <span class="search_icon pointer el-icon-search" color="#999999" ></span> -->
    <el-input
      size="mini"
      :placeholder="$route.name=='tasktodo'||$route.name=='taskdone'?$translate('taskName'):$route.name=='initprocess'?$translate('TemplateName'):placeholder?placeholder:$translate('search')"
      v-model="text"
      prefix-icon="el-icon-search"
      class="search_input"
    ></el-input>
  </div>
</template>
<script>
export default {
  props: {
    handleSearch: {
      type: Function,
      default: () => {
        return null
      }
    },
    placeholder: {
      type: String,
      default: ""
    },
    styleVal: {
        default: ""
    }
  },
  data() {
    return {
      text: '',
      debounceTimer: null
    }
  },
  watch: {
    $route() {
      this.text = ''
    },
    text(val) {
      // 输入为空时，立即触发清空搜索
      if (val === '' || val === null) {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer)
          this.debounceTimer = null
        }
        this.handleSearch('')
        return
      }

      // 输入时，500ms 防抖后自动触发搜索
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.handleSearch(this.text)
      }, 500)
    }
  },
  methods: {
    searchFn() {
      this.handleSearch(this.text)
    }
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }
  }
}
</script>
